export default "__VITE_ASSET__DwtFCL6s__"